const matchCalendar = [
  {
    date: '2025-10-11',
    day: 'Sat',
    startTime: '14:30',
    endTime: '17:30',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Leeds Gorse 2',
    venueType: 'Away',
    location: 'Ruth Gorse Academy'
  },
  {
    date: '2025-10-19',
    day: 'Sun',
    startTime: '15:00',
    endTime: '18:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Everton Narwhals',
    venueType: 'Away',
    location: 'Litherland High School'
  },
  {
    date: '2025-10-25',
    day: 'Sat',
    startTime: '11:30',
    endTime: '14:30',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'The Miners Doncaster',
    venueType: 'Away',
    location: 'Campsmount Academy'
  },
  {
    date: '2025-10-26',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Lincoln Cannons',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2025-11-02',
    day: 'Sun',
    startTime: '14:40',
    endTime: '17:40',
    competition: 'Women\'s National Shield',
    status: 'Completed',
    opponent: 'Manchester Marvels Mystics',
    venueType: 'Away',
    location: 'Dean Trust Ardwick'
  },
  {
    date: '2025-11-08',
    day: 'Sat',
    startTime: '13:00',
    endTime: '16:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Sheffield',
    venueType: 'Away',
    location: 'All Saints Sports Centre'
  },
  {
    date: '2025-11-16',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Manchester Liberators',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2025-11-23',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'The Miners Doncaster',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2025-11-30',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Everton Narwhals',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2025-12-14',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Newcastle Staffs',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2026-01-18',
    day: 'Sun',
    startTime: '16:00',
    endTime: '19:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Completed',
    opponent: 'Lincoln Cannons',
    venueType: 'Away',
    location: 'Riseholme College'
  },
  {
    date: '2026-02-01',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Confirmed',
    opponent: 'Sheffield',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2026-02-08',
    day: 'Sun',
    startTime: '12:30',
    endTime: '15:00',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Confirmed',
    opponent: 'Leeds Gorse 2',
    venueType: 'Home',
    location: 'Moss Side Leisure Centre'
  },
  {
    date: '2026-02-21',
    day: 'Sat',
    startTime: '11:30',
    endTime: '14:30',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Confirmed',
    opponent: 'Manchester Liberators',
    venueType: 'Away',
    location: 'Fairfield High School'
  },
  {
    date: '2026-03-14',
    day: 'Sat',
    startTime: '11:30',
    endTime: '14:30',
    competition: 'NVL Women\'s Division 2 North',
    status: 'Confirmed',
    opponent: 'Newcastle Staffs',
    venueType: 'Away',
    location: 'Madeley High School'
  }
];

export default matchCalendar;
